import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface BuildingModalProps {
  title: string;
  onClose: () => void;
  content: React.ReactNode;
  'data-tutorial'?: string;
}

export const BuildingModal: React.FC<BuildingModalProps> = ({ title, onClose, content, 'data-tutorial': dataTutorial }) => {
  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" {...(dataTutorial ? { 'data-tutorial': dataTutorial } : {})}>
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          className="bg-dark-stone border-2 border-dark-leather rounded-lg p-6 max-w-2xl w-full max-h-[95vh] overflow-y-auto"
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-pixel text-yellow-600">{title}</h2>
            <button
              onClick={onClose}
              className="text-white hover:text-red-500 font-pixel text-xl"
            >
              ✕
            </button>
          </div>
          {content}
        </motion.div>
      </div>
    </AnimatePresence>
  );
};



